import {
  BiBriefcaseAlt2,
  BiCheck,
  BiEnvelope,
  BiFile,
  BiFolder,
  BiFolderOpen,
  BiPrinter,
  BiReceipt,
  BiShareAlt,
  BiSolidFilePdf,
} from "react-icons/bi";
import { ROUTES } from "constants/routes-path";
import { PERMISSIONS } from "../../../constants/permission";

export const ProcessSpecificActions = (
  t,
  navigate,
  openProcessPrintCaPage,
  handleAttachmentDocument,
  handleReassign,
  handleReopen,
  handlePrintLetter
) => [
    {
      label: t("process.list.table.actions.print-ca"),
      icon: <BiSolidFilePdf />,
      permissions: [PERMISSIONS.PROCESS_CREATION],
      onClick: (row) => openProcessPrintCaPage(row.original),
      visible: () => true,
    },
    {
      label: t("process.list.table.actions.received-confirmation"),
      icon: <BiCheck />,
      permissions: [PERMISSIONS.PROCESS_ALLOCATION],
      onClick: row => navigate(
        ROUTES.processesConfirmReceiptPath.replace(":id", row.original.id)
      ),
      visible: values => values.receipt_confirmation_needed
    },
    {
      label: t("process.list.table.actions.forward-process"),
      icon: <BiShareAlt />,
      permissions: [PERMISSIONS.FORWARD_PROCESSES],
      onClick: row => navigate(
        ROUTES.processesForwardPath.replace(":id", row.original.id)
      ),
      visible: values =>
        values.is_editable && !values.receipt_confirmation_needed
    },
    {
      label: t("process.list.table.actions.attach-doc"),
      icon: <BiFile />,
      permissions: [PERMISSIONS.ATTACH_PROCESS_DOCUMENTS],
      onClick: row => handleAttachmentDocument(row.original.id),
      visible: values => values.is_editable
    },
    {
      label: t("process.list.table.actions.judge-process"),
      icon: <BiBriefcaseAlt2 />,
      permissions: [PERMISSIONS.PROCESS_SERVICE],
      onClick: row => navigate(
        ROUTES.judgeProcessesPath.replace(":id", row.original.id)
      ),
      visible: values =>
        values.is_editable && !values.receipt_confirmation_needed
    },
    {
      label: t("process.list.table.actions.print-decision"),
      icon: <BiPrinter />,
      permissions: [
        PERMISSIONS.PROCESS_SERVICE,
        PERMISSIONS.FILL_FINAL_DECISION,
        PERMISSIONS.PRINT_FINAL_DECISION,
      ],
      onClick: row => window.open(
          `${window.location.origin}${ROUTES.processPrintFinalDecision.replace(":id", row.original.id)}`,
          '_blank'
      ),
      visible: values =>
        !values.receipt_confirmation_needed &&
        !values.under_diligence &&
        (values.has_reporter_decision || values.has_final_decision)
    },
    {
      label: t("process.list.table.actions.fill-final-decision"),
      icon: <BiCheck />,
      colorScheme: "green",
      permissions: [PERMISSIONS.FILL_FINAL_DECISION],
      onClick: row => navigate(ROUTES.processesFinalDecisionPath.replace(":id", row.original.id)),
      visible: values =>
        !values.receipt_confirmation_needed &&
        !values.under_diligence &&
        values.is_editable &&
        values.process_judgement_needed &&
        values.has_reporter_decision &&
        !values.has_revision &&
        !values.has_final_decision
    },
    {
      label: t("process.list.table.actions.print-letter"),
      icon: <BiPrinter />,
      permissions: [
        PERMISSIONS.FILL_FINAL_DECISION,
        PERMISSIONS.PRINT_FINAL_DECISION,
        PERMISSIONS.PROCESS_SERVICE,
      ],
      onClick: row => handlePrintLetter(row.original),
      visible: values =>
        !values.receipt_confirmation_needed &&
        !values.under_diligence &&
        values.process_judgement_needed &&
        values.has_final_decision
    },
    {
      label: t("process.list.table.actions.send-email"),
      icon: <BiEnvelope />,
      permissions: [
        PERMISSIONS.FILL_FINAL_DECISION,
        PERMISSIONS.PRINT_FINAL_DECISION,
        PERMISSIONS.PROCESS_SERVICE,
      ],
      onClick: row => navigate(ROUTES.processesSendEmailPath.replace(":id", row.original.id)),
      visible: values =>
        !values.receipt_confirmation_needed &&
        !values.under_diligence &&
        values.process_judgement_needed &&
        values.has_final_decision
    },
    {
      label: t("process.list.actions.reassign-process"),
      icon: <BiReceipt />,
      permissions: [PERMISSIONS.REASSIGN_PROCESSES],
      onClick: row => handleReassign(row.original.id),
      visible: values =>
        values.is_editable &&
        !values.receipt_confirmation_needed
    },
    {
      label: t("process.list.table.actions.file-process"),
      icon: <BiFolder />,
      permissions: [PERMISSIONS.ARCHIVE_PROCESSES],
      onClick: row => navigate(
        ROUTES.processesArchivePath.replace(":id", row.original.id)
      ),
      visible: values =>
        values.is_editable &&
        !values.response_process_creation &&
        !values.response_process_result
    },
    {
      label: t("process.list.table.actions.reopen-process"),
      icon: <BiFolderOpen />,
      permissions: [PERMISSIONS.REOPEN_PROCESSES],
      onClick: row => handleReopen(row.original.id),
      visible: values =>
        !values.is_editable &&
        !values.response_process_creation &&
        !values.response_process_result
    },
    {
      label: t("process.list.table.actions.reexamine-process"),
      icon: <BiFolderOpen />,
      permissions: [PERMISSIONS.REEXAMINE_PROCESSES],
      onClick: row => navigate(ROUTES.processesReexaminationPath.replace(":id", row.original.id)),
      visible: values =>
        !values.decision_before_reexamination && values.process_judgement_meetings_needed && !values.is_editable
    },
  ];
